import gsap from 'gsap';
import Cookies from "js-cookie";

const information = {
    settings: {
        content: document.querySelector('.information__content')
    },
    init: () => {
        const informationContainer = document.querySelector('section.information');
        if (!informationContainer) return;
        
        const buttons = document.querySelector('.information__buttons').children;

        [...buttons].forEach(button => button.addEventListener('click', () => information.accordion(button)))
        information.checkCookies();
    },
    accordion: button => {
        const content = information.settings.content;

        if ( button.classList.contains('hide') ) {
            gsap.to(content, {duration: 0.3, height: 0});

            if ( !Cookies.get('information-hide') ) {
                Cookies.set( 'information-hide', true, { expires: 1/24 } )
            }

            document.querySelector('.information__buttons p.show').classList.add('var_active');
        } else {
            gsap.to(content, {duration: 0.3, height: 'auto'});

            document.querySelector('.information__buttons img.hide').classList.add('var_active');
        }

        button.classList.toggle('var_active');

    },
    checkCookies: () => {
        if ( Cookies.get('information-hide') ) {
            const content = information.settings.content;
            gsap.set(content, {height: 0});

            document.querySelector('.information__buttons p.show').classList.add('var_active');
            document.querySelector('.information__buttons img.hide').classList.remove('var_active');
        }
    }
}
export default information;